import React from 'react'
import Link from 'gatsby-link'
import './style.scss'

const FooterNav = ({data}) => {
  return (
    <div className='footerNav-wrapper'>
      <div className='grid'>
        <div className='grid-1of3 grid-1of1--ipad u-alignCenter--ipad'>
          <span className='footerNav-text'>{data.footerCopyrights}</span>
        </div>
        <div className='grid-1of3 u-alignCenter grid-1of1--ipad'>
          <Link className='footerNav-logo-anchor' to='/'>
            <img className='footerNav-logo'src='/images/logo.svg' alt='logo'/>
          </Link>
        </div>
        <div className='grid-1of3 u-alignRight grid-1of1--ipad u-alignCenter--ipad'>
          <div className='u-marginBottomXxsmall'>
            <span className='footerNav-text'>{data.footerAddress}</span>
          </div>
          <a href='http://twg.io' target='_blank' className='footerNav-text footerNav-text--secondary'>Website by TWG</a>
        </div>
      </div>
    </div>
  )
}

export default FooterNav



// WEBPACK FOOTER //
// ./src/components/footer-nav/index.js